module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0112.jpg?v=423a69b7";